import Checkbox from "@/manager/components/checkbox/checkbox";

export interface IBooleanWidget {
  id: string;
  type: "boolean";
  modalType: "datamodelField";
  label: string;
  required: boolean;
  readonly: boolean;
}

interface IBooleanWidgetProps {
  widget: IBooleanWidget;
  value: string | boolean | undefined;
  onChange?: (newValue: string, key?: string) => void;
}

const BooleanWidget = ({ widget, value = false, onChange }: IBooleanWidgetProps) => {
  const isChecked = value === true || value === "true";

  return (
    <div className="booleanWidget">
      <Checkbox
        label={`${widget.label}${widget.required ? " *" : ""}`}
        disabled={widget.readonly}
        required={widget.required}
        checked={isChecked}
        onClick={() => onChange && onChange((!isChecked).toString(), widget.id)}
      />
    </div>
  );
};

export default BooleanWidget;